import { Injectable, Optional } from '@angular/core';

@Injectable()
export class BootstrapParams {
  public rootApiUrl: string;
  public googleMapKey: string;
  public bingMapKey: string;
  public bingMapCountryFilter: string;
  public useBingMaps: boolean;
  public MessagingRootApiUrl: string;
  public RegistrationRootApiUrl: string;
  public OrchestrationRootApiUrl: string;
  public PaymentRootApiUrl: string;
  public MetricRootApiUrl: string;
  public LpiParams: string;
  public SessionTime: string;
  public expiresIn: string;
  public Token: string;
  public RefreshPriorExp: string;
  public googleRegion: string;
  // SeatHoldTime vs.LongSeatHoldTime:
  // Both are used for the slot timer on the top of the page that kicks you back to the slot selection
  // SeatHoldTime is the default that is used for the majority of clients
  // LongSeatHoldTime was added as an override for CBAP becasue they only use QR payments and have a lengthy demographics page,
  // leading to insufficient time to initialize QR payments
  public seatHoldTime: string;
  public longSeatHoldTime: string;
  public longSeatHoldTimeClients: string[];
  public candidateGuid: string;
  public cmsUrl: string;
  public clientCode: string;
  public candidateLastName: string;
  public legacyCancel: boolean;
  public logConsoleToDB: boolean;
  public hideBiometricsClients: string[];
  public sessionGuid: string;
  public hiddenClient: boolean;
  public extendHoldTime: number; // time in minutes to extend hold by when redirecting to payment
  public proctorTakeSize: number;
  public captchaEnable: boolean;
  public defaultSearchDateRange: number;
  public testCenterCalendarDays: number;
  public testCenterTakeSize: number;
  public paymentOrchestratorPollingTime: number; // time in ms between polling calls for payment orchestrator
  public paymentOrchestratorPollingLimit: number; // time to poll for payment status before quitting
  public paymentOrchestratorRetryTime: number; // time between calls of create session or rollback transaction if the calls don't succeed the first time
  public paymentOrchestratorMaxRetries: number; // maximum number of times to retry create session or rollback calls if they don't succeed
  public testingWindowDisplayYears: number; // maximum number of years until the end date to display testing window
  public displayTaxDisclaimer: boolean;
  public volumeGovernanceEnabled: boolean;
  public volumeGovernanceAzureFunctionUrl: string;
  public volumeGovernanceAzureFunctionKey: string;
  public lsacPrograms: string[];

  constructor(
    @Optional() rootApiUrl: string,
    @Optional() googleMapKey?: string,
    @Optional() bingMapKey?: string,
    @Optional() bingMapCountryFilter?: string,
    @Optional() useBingMaps?: boolean,
    @Optional() messagingRootApiUrl?: string,
    @Optional() registrationRootApiUrl?: string,
    @Optional() orchestrationRootApiUrl?: string,
    @Optional() paymentRootApiUrl?: string,
    @Optional() metricRootApiUrl?: string,
    @Optional() lpiParams?: string,
    @Optional() sessionTime?: string,
    @Optional() expiresIn?: string,
    @Optional() token?: string,
    @Optional() refreshPriorExp?: string,
    @Optional() googleRegion?: string,
    @Optional() candidateGuid?: string,
    @Optional() cmsUrl?: string,
    @Optional() clientCode?: string,
    @Optional() seatHoldTime?: string,
    @Optional() longSeatHoldTime?: string,
    @Optional() longSeatHoldTimeClients?: string,
    @Optional() candidateLastName?: string,
    @Optional() legacyCancel?: boolean,
    @Optional() logConsoleToDB?: boolean,
    @Optional() hideBiometricsClients?: string,
    @Optional() sessionGuid?: string,
    @Optional() hiddenClient?: boolean,
    @Optional() extendHoldTime?: string,
    @Optional() failedLibs?: any, // Dictionary, but not our Dictionary
    @Optional() proctorTakeSize?: string,
    @Optional() captchaEnable?: boolean,
    @Optional() defaultSearchDateRange?: string,
    @Optional() testCenterCalendarDays?: string,
    @Optional() testCenterTakeSize?: string,
    @Optional() paymentOrchestratorPollingTime?: string,
    @Optional() paymentOrchestratorPollingLimit?: string,
    @Optional() paymentOrchestratorRetryTime?: string,
    @Optional() paymentOrchestratorMaxRetries?: string,
    @Optional() testingWindowDisplayYears?: string,
    @Optional() displayTaxDisclaimer?: boolean,
    @Optional() volumeGovernanceEnabled?: boolean,
    @Optional() volumeGovernanceAzureFunctionUrl?: string,
    @Optional() volumeGovernanceAzureFunctionKey?: string,
    @Optional() lsacPrograms?: string
  ) {
    this.rootApiUrl = rootApiUrl;
    this.googleMapKey = googleMapKey;
    this.bingMapKey = bingMapKey;
    this.bingMapCountryFilter = bingMapCountryFilter;
    this.useBingMaps = useBingMaps;
    this.MessagingRootApiUrl = messagingRootApiUrl;
    this.RegistrationRootApiUrl = registrationRootApiUrl;
    this.OrchestrationRootApiUrl = orchestrationRootApiUrl;
    this.PaymentRootApiUrl = paymentRootApiUrl;
    this.MetricRootApiUrl = metricRootApiUrl;
    this.LpiParams = lpiParams;
    this.SessionTime = sessionTime;
    this.RefreshPriorExp = refreshPriorExp;
    this.Token = token;
    this.expiresIn = expiresIn;
    this.googleRegion = googleRegion;
    this.seatHoldTime = seatHoldTime;
    this.longSeatHoldTime = longSeatHoldTime;
    this.longSeatHoldTimeClients = !!longSeatHoldTimeClients ? longSeatHoldTimeClients.toUpperCase().split(',') : [];
    this.candidateGuid = candidateGuid;
    this.cmsUrl = cmsUrl;
    this.clientCode = clientCode;
    this.candidateLastName = candidateLastName;
    this.legacyCancel = legacyCancel;
    this.logConsoleToDB = logConsoleToDB;
    this.hideBiometricsClients = !!hideBiometricsClients ? hideBiometricsClients.toUpperCase().split(',') : [];
    this.sessionGuid = sessionGuid;
    this.hiddenClient = hiddenClient;
    this.extendHoldTime = +extendHoldTime;
    this.proctorTakeSize = +proctorTakeSize;
    this.captchaEnable = captchaEnable;
    this.defaultSearchDateRange = +defaultSearchDateRange;
    this.testCenterCalendarDays = +testCenterCalendarDays;
    this.testCenterTakeSize = +testCenterTakeSize;
    this.paymentOrchestratorPollingTime = +paymentOrchestratorPollingTime;
    this.paymentOrchestratorPollingLimit = +paymentOrchestratorPollingLimit;
    this.paymentOrchestratorRetryTime = +paymentOrchestratorRetryTime;
    this.paymentOrchestratorMaxRetries = +paymentOrchestratorMaxRetries;
    this.testingWindowDisplayYears = +testingWindowDisplayYears;
    this.displayTaxDisclaimer = displayTaxDisclaimer;
    this.volumeGovernanceEnabled = volumeGovernanceEnabled;
    this.volumeGovernanceAzureFunctionUrl = volumeGovernanceAzureFunctionUrl;
    this.volumeGovernanceAzureFunctionKey = volumeGovernanceAzureFunctionKey;
    this.lsacPrograms = !!lsacPrograms ? lsacPrograms.toUpperCase().split(',') : [];
  }
}
